// const env = 'dev'
const env = 'prod'
export const baseUrl = env === 'dev' ? 'https://cim-test.dingding.sirun.net/' : 'https://cim.dingding.sirun.net/'
